// extracted by mini-css-extract-plugin
export default {"btn":"ScrollTop_btn__lToss"};